define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var NumberImportModel = /** @class */ (function () {
        function NumberImportModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable();
            this.CustomerName = ko.observable();
            this.CreateStatusIfNotExist = ko.observable(false);
            this.CreateProviderIfNotExist = ko.observable(false);
            this.CreateTypeIfNotExist = ko.observable(false);
            this.CreateOfficeLocationIfNotExist = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, NumberImportModel.Mapping, self);
            }
        }
        NumberImportModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new NumberImportModel(options.data);
            }
        };
        return NumberImportModel;
    }());
    return NumberImportModel;
});
//# sourceMappingURL=NumberImportModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/NumberImportModel.js
// module id = 194
// module chunks = 2